import { useEffect } from 'react';
import { initializeFeatureFlags } from 'stores/featureFlagsStore';

/** Loads the org's feature flags once the session has a user and an org. */
export const useFeatureFlagsInit = (
  isAuthenticated: boolean,
  userId: string | null,
  orgId: string | null
): void => {
  useEffect(() => {
    if (isAuthenticated && userId && orgId) {
      initializeFeatureFlags();
    }
  }, [isAuthenticated, userId, orgId]);
};
